import React, { useState, useEffect, useRef } from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox, MaskedTextBox } from "@progress/kendo-react-inputs";
import { nomService } from "../../services/api/nom.service";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import { alertService } from '../../services/helpers/alert.service';
import { utils } from "../../services/helpers/utils";
import { partnerService } from '../../services/api/partner.service';
import { CustomDropdown } from "../shared/customDropdown";

export const DialogDoctor = ({ doctor, toggleDialog, setRefresh }) => {

	const formRef = useRef();
	const partener = sessionStorage.getItem("idPartener");

	doctor = (!doctor) ? {
		id: 0,
		idPartener: partener,
		nume: "",
		prenume: "",
		parafa: "" ,
		cnp: "",
		idSpecialitate: null,
		idTip: null,
		extern: 1,
		intern: 0,
		email:  "",
		telefon: "",
		activ: 1
	} : doctor;

	doctor.telefon = doctor.telefon ?? "";
	doctor.activ = (doctor.activ == 1 ? true : false);
	doctor.extern = (doctor.extern == 1 ? true : false);
	doctor.intern = (doctor.intern == 1 ? true : false);

	const title = doctor.id ? "Detaliu medic" : "Adauga medic";

	const numeValidator = (value) => (value ? "" : "Completati campul nume!");
	const prenumeValidator = (value) => (value ? "" : "Completati campul prenume!");
	const parafaValidator = (value) => (value ? "" : "Completati campul parafa!");
	const specialitateValidator = (value) => (value ? "" : "Completati campul specialitate!");
	const tipMedicValidator = (value) => (value ? "" : "Completati campul tip medic!");

	const verify = (data) => {
		//if (!data.nume)    { alertService.error("Completati campul nume!"); return false; }
		//if (!data.prenume) { alertService.error("Completati campul prenume!"); return false; }
		//if (!data.parafa)  { alertService.error("Completati campul parafa!"); return false; }
		//if (!data.specialitate) { alertService.error("Completati campul specialitate!"); return false; }
		//if (!data.tipMedic) { alertService.error("Completati campul tip medic!"); return false; }
		if (data.cnp && !utils.isCNPValid(data.cnp)) { alertService.error("CNP invalid!"); return false; }
		if (data.email && !utils.isEmailValid(data.email)) { alertService.error("Email invalid!"); return false; }
		return true;
	}

	const onFormSubmit = (data) => {
		// actualizează datele doctorului
		// probabil vei dori să trimiți aceste date către server folosind partnerService
		if (!verify(data)) return;

		let medic = {
			id: data.id ?? 0,
			idPartener: partener,
			nume: data.nume,
			prenume: data.prenume,
			parafa: data.parafa,
			cnp: data.cnp,
			specialitate: data?.specialitate?.id,
			tipMedic: data.tipMedic.id,
			extern: data.extern ? 1 : 0,
			intern: data.intern ? 1 : 0,
			email: data.email,
			telefon: data.telefon,
			activ: data.activ ? 1 : 0
		}


		partnerService.saveDoctor(medic).then(response => {
			if (response) {
				alertService.success("Medicul a fost salvat cu succes!");
				setRefresh(true);
			}
		});

	
	}


	return (

		<Form ref={formRef} onSubmit={onFormSubmit} initialValues={doctor} render={() => (
			<Dialog title={title} onClose={toggleDialog} >
				<FormElement style={{ width: 400 }}>
					<h2 className="titlu" data-name="titlu"> { title } </h2>
					<Field name="nume" component={Input} label="Nume *" validator={numeValidator} />
					<Field name="prenume" component={Input} label="Prenume *" validator={prenumeValidator} />
					<Field name="parafa" component={Input} label="Parafa *" validator={parafaValidator} />
					<Field name="cnp" component={Input} label="CNP" maxLength="13" />
					<Field name="telefon" component={MaskedTextBox} mask="0000-000-000" label="Telefon"  />
					<Field name="intern" component={Checkbox} label="Intern" className="mt10 mb10" />
					<Field name="extern" component={Checkbox} label="Trimitator" className="mt10 mb10" />
					<Field name="email" component={Input} label="Email"  />
					<Field name="specialitate"
						component={CustomDropdown}
						request={nomService.getSpecialities}
						initialValue={doctor.idSpecialitate}
						label="Specialitate *"
						validator={specialitateValidator}
					/>
					<Field name="tipMedic" component={CustomDropdown}
						request={nomService.getDoctorsType}
						initialValue={doctor.idTip}
						label="Tip medic *"
						validator={tipMedicValidator}
					/>
					<Field name="activ" component={Checkbox} label="Activ" className="mt10" />
				
				<DialogActionsBar>
					<button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
						type="submit"> Salveaza </button>
					<button
						className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
						onClick={toggleDialog}> Inchide </button>
					</DialogActionsBar>
				</FormElement>
			</Dialog>
		)} />
     
    );
}